import { Routes } from '@angular/router';
import { DashboardComponent } from '../modules/dashboard/dashboard.component';

export const homeRoutes: Routes = [
  {
    path: '',
    component: DashboardComponent,
  },
];
